import React, { useEffect, useState } from "react";
import { onAuthStateChanged } from '@firebase/auth';

import { auth } from "../../services/FirebaseConfig";
import LoaderCircular from '../LoaderCircular';

export const AuthContext = React.createContext();

export const AuthProvider = ({ children }) => {
    const [currentUser, setCurrentUser] = useState(null);
    const [pending, setPending] = useState(true);

    useEffect(() => {

        onAuthStateChanged(auth, currentUser => {
            setCurrentUser(currentUser)
            setPending(false)
        })

    }, []);


    if (pending) {
        return (
            <LoaderCircular open={true} />
        )
    }

    return (
        <AuthContext.Provider
            value={{
                currentUser
            }}
        >
            {children}
        </AuthContext.Provider>
    );
};
